module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASCAYAAABvqT8MAAAAAXNSR0IArs4c6QAAAMtJREFUKBWlkk0OgyAQhflpvINLzgCadNc7NF7BXQ+kp3HXBMMZXHqHJogMVQJWrGlnMw94H8xLQOiXEkI0VVVlZ1gCJmNMPQxDxznPv0EOWKCr7aosS+jJ8sDiyLXWXVEUdYrYAuDLpmlqUrn2AHd5KlcSAMpCH7kOAfcUQlGuM8DCvdslWu0vRkrpXUr5hOPDFzDGYOKr+RCw5pYxdlNKjWBcC4OwX8KsG7a/CCGPvu/bYM/LbYZoXu8KhM+wN2/g89IBqXm96x8xAyKESqkdXG/nAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 0